import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqItems } from "@/mocks/site";
import Hero from "@/pages/home/components/Hero";
import ProgressBand from "@/pages/home/components/ProgressBand";
import TimelinePreview from "@/pages/home/components/TimelinePreview";
import EvidencePreview from "@/pages/home/components/EvidencePreview";
import NotesPreview from "@/pages/home/components/NotesPreview";
import SourceLevels from "@/pages/home/components/SourceLevels";
import TipCta from "@/pages/home/components/TipCta";

const homeFaq = faqItems.slice(0, 4);

export default function Home() {
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "511 求证档案",
      description:
        "围绕 511 爆料 做细节补充、时间线整理、来源求实与证据对照的公开信息整理站点。",
      email: "verify@511-archive.example.com",
      knowsAbout: ["511爆料", "时间线整理", "来源求实", "证据对照"],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "511 求证档案",
      alternateName: "511 爆料求证档案",
      inLanguage: "zh-CN",
      description:
        "提供 511 爆料细节补充与时间线整理，做来源求实与证据对照，逐条标注可信度。",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "511爆料求证档案｜细节补充与时间线整理",
      description:
        "围绕 511 爆料 做细节补充、时间线整理、来源求实与证据对照，逐条标注可信度。",
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: homeFaq.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
  ];

  return (
    <SiteLayout>
      <PageMeta
        title="511爆料求证档案｜511爆料细节补充与时间线整理"
        description="511爆料求证档案，专注511爆料的细节补充与时间线整理，做来源求实与证据对照，逐条标注可信度，帮你还原前后脉络、看清疑点。"
        keywords="511爆料,511爆料细节补充,511爆料前后对照,511爆料来源求实,511爆料时间线整理"
        path="/"
        schema={schema}
      />
      <Hero />
      <ProgressBand />
      <TimelinePreview />
      <EvidencePreview />
      <NotesPreview />
      <SourceLevels />

      <section className="w-full border-t border-background-200 bg-background-100 px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="mb-6 md:mb-8">
          <p className="text-xs font-medium tracking-[0.25em] text-primary-700">
            FAQ
          </p>
          <h2 className="mt-2 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            求证党常问的几个问题
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于状态标注、来源独立性与更正机制的说明，先看这里，再看材料。
          </p>
        </div>
        <FaqAccordion items={homeFaq} />
        <div className="mt-5">
          <Link
            to="/faq"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
          >
            查看全部常见问题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
          </Link>
        </div>
      </section>

      <TipCta />
    </SiteLayout>
  );
}